<template lang="pug">
.ride-card-out-container
  myRideCard(
    v-if="myRideCardModuleData"
    :moduleData="myRideCardModuleData"
    @buyUpgrade="buyUpgrade"
  )
  NewTransferTab(
    v-if="tabList && tabList.length > 1"
    :show="shouldShowTab"
    :activeTabKey="activeTabKey"
    :isApp="isApp"
    :tabs="tabList"
    :tabCode="activeTabKey"
    :type="2"
    @change="handleTabChange"
  )
  div(
    v-for="(item, index) in rideCardModuleData"
    :key="getTabKey(item) || index"
  )
    KeepAlive
      NewRideCardPage(
        v-if="isActiveTab(item)"
        :rideCardData="getRideCardData(item)"
        :propVersion="propVersion || item.propVersion || rideCardModulePropVersion"
        :newTabCode="activeTabKey"
        @refresh="refresh"
      )
  //-  购买单车卡 | 0.01元升级
  buyMemberModal(
    ref="buyMemberModal"
    :show.sync="showBuyMemberModal"
    :buyMemberData="buyMemberData"
    @showRead="showReadFn"
    :isnew="isUpgrade"
    :isUpgrade="isUpgrade"
    :propVersion="propVersion || rideCardModulePropVersion"
  )
  readModal(
    :show="showRead"
    @close="showRead=false"
    @readOk="readOk"
  )
</template>

<script>
import { safeGet } from '@/utils';
import NewRideCardPage from './new-member/new-ride-card-page.vue';
import NewTransferTab from './new-transfer-tab.vue';
import myRideCard from './new-member/my-ride-card.vue';
import buyMemberModal from './new-member/buy-member-modal.vue';
import readModal from './read-modal.vue';

export default {
  name: 'RideCardContainer',
  components: {
    NewRideCardPage,
    NewTransferTab,
    myRideCard,
    buyMemberModal,
    readModal,
  },
  props: {
    // 接收 rideCardItem 的所有 moduleInfos
    moduleInfos: {
      type: Array,
      default: () => [],
    },
    propVersion: {
      type: String,
      default: '',
    },
    isApp: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      activeTabKey: '',
      showBuyMemberModal: false,
      showRead: false,
      buyMemberData: {},
      isUpgrade: false,
    };
  },
  computed: {
    /**
     * 获取 page_my_card_module 的 moduleData
     */
    myRideCardModuleData() {
      if (!Array.isArray(this.moduleInfos) || this.moduleInfos.length === 0) {
        return null;
      }
      const myCardModule = this.moduleInfos.find(
        (module) => module && module.moduleCode === 'page_my_card_module',
      );

      if (myCardModule
        && Object.keys(myCardModule).length > 0
        && myCardModule.moduleData
        && Object.keys(myCardModule.moduleData).length > 0
      ) {
        const rideCardInfo = safeGet(this.rideCardModule, 'moduleData.moduleInfos', null);
        const bikeInfo = rideCardInfo.find((info) => info.tabCode === 'bike');
        const myCardInfo = safeGet(bikeInfo, 'moduleData.moduleInfos', null);
        if (myCardInfo) {
          const infos = myCardInfo.find((info) => info.moduleCode === 'page_vip_recommend_coupon_visualization_module');
          if (infos) {
            myCardModule.moduleData.propertyDetailDTOS = infos.moduleData.propertyDetailDTOS;
            myCardModule.moduleData.commonBonus = infos.moduleData.commonBonus;
          }
        }
      }
      return safeGet(myCardModule, 'moduleData', null);
    },
    /**
     * 获取 ride_card_module 模块
     */
    rideCardModule() {
      if (!Array.isArray(this.moduleInfos) || this.moduleInfos.length === 0) {
        return null;
      }
      return this.moduleInfos.find(
        (module) => module && module.moduleCode === 'ride_card_module',
      ) || null;
    },
    /**
     * 获取 ride_card_module 的 moduleData.moduleInfos（传递给 rideCardPage）
     */
    rideCardModuleData() {
      const moduleInfos = safeGet(this.rideCardModule, 'moduleData.moduleInfos', null);
      return moduleInfos;
    },
    /**
     * 获取 ride_card_module 的 propVersion
     */
    rideCardModulePropVersion() {
      return safeGet(this.rideCardModule, 'propVersion', '');
    },
    /**
     * 从 ride_card_module.moduleData.moduleInfos 中提取子 tab 信息
     */
    subTabModules() {
      const moduleInfos = this.rideCardModuleData;
      if (!Array.isArray(moduleInfos) || moduleInfos.length === 0) {
        return [];
      }

      // 提取有 tabCode 的模块作为子 tab
      return moduleInfos.filter(
        (module) => module && module.tabCode,
      );
    },
    /**
     * 生成 tabList 用于 TransferTab
     */
    tabList() {
      if (this.subTabModules.length === 0) {
        return [];
      }

      return this.subTabModules
        .map((module) => {
          const tabKey = this.getTabKey(module);
          if (!tabKey) {
            return null;
          }
          return {
            tabKey,
            title: module.tabName || '',
            subTitle: module.subTitle || '',
            logoImg: module.logoImg || '',
          };
        })
        .filter(Boolean); // 过滤掉 null 值
    },
    shouldShowTab() {
      return this.tabList && this.tabList.length > 1 && !!this.activeTabKey;
    },
  },
  watch: {
    moduleInfos: {
      immediate: true,
      deep: true,
      handler() {
        this.initActiveTab();
      },
    },
    activeTabKey: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$emit('tabChange', { tabKey: newVal });
        }
      },
    },
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    /**
     * 获取 tabKey，直接使用 tabCode
     */
    getTabKey(module) {
      return module.tabCode || '';
    },
    /**
     * 获取传递给 rideCardPage 的数据
     * 如果模块有 moduleData.moduleInfos，使用它；否则将当前模块包装成数组
     */
    getRideCardData(item) {
      if (!item) {
        return [];
      }
      // 如果模块有 moduleData.moduleInfos，使用它
      if (item.moduleData && Array.isArray(item.moduleData.moduleInfos)) {
        return item.moduleData.moduleInfos;
      }
      // 否则将当前模块包装成数组
      return [item];
    },
    /**
     * 判断当前 item 是否是激活的 tab
     */
    isActiveTab(item) {
      if (!item || !item.tabCode) {
        return false;
      }
      return item.tabCode === this.activeTabKey;
    },
    /**
     * 初始化激活的 tab
     */
    initActiveTab() {
      if (this.subTabModules.length === 0) {
        this.activeTabKey = '';
        return;
      }

      // 查找 anchor 为 true 的模块
      const anchorModule = this.subTabModules.find((module) => module.anchor === true);
      if (anchorModule) {
        this.activeTabKey = this.getTabKey(anchorModule);
      } else if (this.subTabModules.length > 0) {
        // 如果没有 anchor，使用第一个
        this.activeTabKey = this.getTabKey(this.subTabModules[0]);
      }
    },
    /**
     * 处理 tab 切换
     */
    handleTabChange({ tabKey }) {
      this.activeTabKey = tabKey;
    },
    /**
     * 显示阅读协议弹窗
     */
    showReadFn() {
      this.showRead = true;
    },
    /**
     * 购买会员
     */
    buyMember(val, isUpgrade = false) {
      this.buyMemberData = val;
      this.showBuyMemberModal = true;
      this.isUpgrade = isUpgrade;
    },
    /**
     * 升级购买（我的卡升级）
     */
    buyUpgrade(val) {
      this.buyMember(val, true);
    },
    /**
     * 阅读协议确认
     */
    readOk() {
      this.$refs.buyMemberModal.readOk();
    },
  },
};
</script>

<style lang="less" scoped>
.ride-card-out-container {
  width: 100%;
}
</style>
